<template>
  <router-link
    :to="{ name: PATH_INVOICE }"
    @click.native="handleClick"
    v-if="!isButtonHidden"
  >
    <Button
      class="el-button--only-icon-for-xxs"
      icon="icon icon-invoice-new"
      new-design
      size="large"
      type="warning"
    >
      {{ config.createInvoiceButton.text }}
    </Button>
  </router-link>
</template>

<script>
import { PATH_INVOICE, PATH_INVOICE_TEMPLATE_SHOW } from '~/router';
import { navbarConfig } from '~/config/navbarConfig';

export default {
  data: () => ({
    PATH_INVOICE,
    PATH_INVOICE_TEMPLATE_SHOW,
  }),
  computed: {
    isButtonHidden() {
      return this.$route.name === PATH_INVOICE_TEMPLATE_SHOW || this.$route.name === PATH_INVOICE;
    },
    config() {
      return this.$i18n.locale === 'en' ? navbarConfig.usa : navbarConfig.default;
    },
  },
  methods: {
    handleClick() {
      this.$emit('handle-click');
    },
  },
};
</script>
